<template>
  <component :is="component" @multiActionEdit="multiActionEdit" @setComponent="setComponent" :action_id="action_id" @loading="setLoading($event)"></component>
</template>

<script>
import MultiActionEdit from './MultiActionsEdit.vue';
import MultiActionList from './MultiActionsList.vue';
export default {
name: "VoteSystyem",
components: {
  MultiActionEdit,
  MultiActionList
},
data() {
  return {
    component: 'MultiActionList',
    action_id: null,
    breadcrumb: {
      show: false,
      name: ''
    }
  };
},
methods: {
  setComponent(payload) {
    this.component = payload
  },
  multiActionEdit(item) {
    this.component = 'MultiActionEdit';
    this.action_id = item.action_id;
    this.breadcrumb.name = item.name;
  },
  setLoading(value) {
    this.$emit('loading', value)
  }
},
watch: {
  component(value) {
    this.breadcrumb.show = (value == 'MultiActionEdit') ? true : false;
    this.$emit('setBreadcrumb', this.breadcrumb);
  }
},
created() {
  this.$emit('loading', true)
    setTimeout(() => {
      this.$emit('loading', false)
    }, 1000);
  },
  beforeDestroy() {
    this.breadcrumb.show = false;
    this.$emit('setBreadcrumb', this.breadcrumb);
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/MultiActions.vue